<!-- 岗位管理 -->
<template>
	<div class="box">
    <div class="container">
     <div class="btnList">
        <div>
          <el-button type="primary" @click="addList" size="mini" >新增</el-button>
          <el-button   size="mini" @click="allDel" >批量删除</el-button>
        </div>

     </div>
     <div class="btnList2">
            <searchForm
            :labels="labels"
            @input="handleInput"
            @search="handleSearch"
            @reset="handleReset"
          />

     </div>
    <div class="table_content">
        <r-table
        ref='tableRef'
        :config="config"
        v-loading="loading"
        :tableData="tableData"
        :tableHeader="tableHeader"
        :pageObj="pageObj"
        @handleSizeChange="sizeChange"
        @handleCurrentChange="currentChange"
        @selection-change='handleSelectionClick'>
        <template slot-scope="scope" slot="enabled">
          <span v-if="scope.row.enabled == 1">
            启用
          </span>
          <span v-if="scope.row.enabled == 2">
            停用
          </span>
        </template>
        <template slot-scope="scope" slot="operate">
            <div>
                <el-popover
                  placement="left"
                  width="80px"
                  trigger="hover"
                  content="">
                    <div class="operate_btn">
                      <div @click="edit(scope.row)">编辑</div>
                      <div @click="del(scope.row.id)">删除</div>
                    </div>
                   <svg-icon iconClass="more" class="more" slot="reference"></svg-icon>
                </el-popover>

            </div>
        </template>
      </r-table>
    </div>
     </div>
     <el-dialog
      :visible.sync="showAddDialog"
      width="800px"
      >
      <div slot="title" class="dialogTitle">
          {{ dislogTitle }}
      </div>
      <el-form :label-position="'left'"  label-width="80px"  :model="formLabelAlign" :rules="rules" ref="formLabelAlign">
        <el-row>
          <el-col :span="12">
            <el-form-item label="岗位名称" prop="name" >
              <el-input v-model="formLabelAlign.name" placeholder="请填写岗位名称" type="name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="岗位类型" prop="post_type">
              <el-select v-model="formLabelAlign.post_type" placeholder="请选择岗位类型">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>
       </el-row>
       <el-row>
        <el-col :span="12">
            <el-form-item label="描述" prop="description">
              <el-input v-model="formLabelAlign.description" placeholder="描述"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序编号" prop="sort">
              <el-input v-model="formLabelAlign.sort" placeholder="排序编号(数字越小排名越靠前)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="岗位状态" prop="enabled">
              <el-radio-group v-model="formLabelAlign.enabled">
                <el-radio label="1" >启用</el-radio>
                <el-radio label="2" >停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
    </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('formLabelAlign')" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('formLabelAlign')" size="small" :loading="addBtn_confirm">确 定</el-button>
      </div>
    </el-dialog>

	</div>
</template>
<script>
import rTable from '@/components/Table';
import searchForm from '@/components/searchForm';
import { getPostList, postSave, postDelete } from '@/api/common.js'
import { mapGetters } from 'vuex';
export default {
  components: {
    rTable, searchForm
  },
  computed: {
    ...mapGetters(['headerBg'])
  },
  data () {
    return {
      selection: [],
      addBtn_confirm: false,
      searchParams: {
        k: '',
        k_enabled: '',
        k_post_type: '',
      },
      pageObj: {
        page_size: 10,
        current_page: 1,
        total_count: 0
      },
      options: [
        { label: "类别1", value: "1" },
        { label: "类别2", value: "2" },
      ],
      dislogTitle: '新增',
      rules: {
        name: [
          { required: true, message: '请填写岗位名称', trigger: ['change', 'blur'] }
        ],
        post_type: [
          { required: true, message: '请选择岗位类型', trigger: ['change', 'blur'] }
        ],
        k_enabled: [
          { required: true, message: '岗位状态不能为空', trigger: ['change', 'blur'] }
        ],
        sort: [
          { required: true, message: '排序编号不能为空', trigger: ['change', 'blur'] }
        ]

      },
      formLabelAlign: {
        name: '',
        post_type: '',
        description: '',
        enabled: '1',
        sort: ''
      },
      config: {
        isSelection: true,       //显示复选框
        isRowClick: false,       //使用行点击
        isStripe: true,         //隐藏斑马纹，与背景色不可同时用
        tableHeight: '100%',        //表格高度
        isShowSummary: false,     //显示共计
        isIndex: false,           //自定义序号
      },
      tableHeader: [
        {
          prop: 'post_type',       //字段
          colWidth: '',    //宽度
          title: '岗位类别',       //表头
          isSort: false,       //是否排序
          type: '',       //link:跳转,
          align: 'left',
        },
        {
          prop: 'name',       //字段
          colWidth: '',    //宽度
          title: '岗位名称',       //表头
          isSort: false,       //是否排序
          type: '',       //link:跳转,
          align: 'left',
        },						// button:文字按钮,

        {
          prop: 'description',       //字段
          colWidth: '',    //宽度
          title: '岗位描述',       //表头
          isSort: false,       //是否排序
          type: '',       //link:跳转,
          align: 'center',
        },
        {
          prop: 'sort',       //字段
          colWidth: '',    //宽度
          title: '排序',       //表头
          isSort: false,       //是否排序
          type: '',       //link:跳转,
          align: 'center',
        },
        {
          prop: 'enabled',       //字段
          colWidth: '',    //宽度
          title: '岗位状态',       //表头
          isSort: false,       //是否排序
          type: 'slot',       //link:跳转,
          align: 'center',
        },
        {
          prop: 'operate',       //字段
          colWidth: '52px',    //宽度
          title: '操作',       //表头
          isSort: false,       //是否排序
          type: 'slot',       //link:跳转,
          align: 'center',
        },

      ],
      loading: false,
      showAddDialog: false,
      tableData: [
      ],
      spanList: [],  //合并单元格
      spanList2: [],
      orderList: [{ column: '', asc: false }],  // 默认, asc:false 倒序
      k_enabled: 0,
      k: '',
      k_post_type: '',
      isShowSearch: true,
      labels: [
        {
          name: 'k',
          title: '岗位名称',
          type: 'input',
          placeholder: '请输入' + '岗位名称'
        }, {
          name: 'k_enabled',
          title: '岗位状态',
          type: 'select',
          placeholder: '请选择' + '岗位状态',
          selectData: [
            { label: "启用", value: "1" },
            { label: "停用", value: "2" },
          ],
        }, {
          name: 'k_post_type',
          title: '岗位类别',
          type: 'select',
          placeholder: '请选择' + '岗位类别',
          selectData: [
            { label: "类别1", value: "1" },
            { label: "类别2", value: "2" },
          ],
        },
      ],
    }
  },
  mounted () {
    this.getList();
  },
  methods: {
    allDel () {
      if (!this.selection.length) { return this.$toast.warning('请选择要删除的数据') }
      let ids = []
      for (let val of this.selection) {
        ids.push(val.id)
      }
      this.del(ids.join(','))
    },
    edit (row) {
      this.formLabelAlign = { ...row }
      this.showAddDialog = true
    },
    del (row) {
      this.$confirm('是否删除选中数据？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认删除',
        cancelButtonText: '取消'
      })
        .then(() => {
          postDelete({ 'ids': row }).then(res => {
            if (res.code == 200) {
              this.$toast.success(res.msg ? res.msg : '')
              this.getList()
            } else {
              this.$toast.warning(res.msg ? res.msg : '')
            }
          })
        })
    },
    resetAll () {

    },
    handleInput () {
    },
    handleSearch (val) {
      this.searchParams = val
      this.getList()
    },
    handleReset (val) {
      this.searchParams = val
      this.pageObj.current_page = 1
      this.getList()
    },
    sizeChange (row) {
      this.pageObj.page_size = row
      this.getList()
    },
    currentChange (row) {
      this.pageObj.current_page = row
      this.getList()
    },
    go (url) {
      this.$router.push(url)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addBtn_confirm = true
          postSave(this.formLabelAlign).then(res => {
            if (res.code == 200) {
              this.$toast.success(res.msg ? res.msg : '添加成功')
              this.showAddDialog = false
            } else {
              this.$toast.warning(res.msg ? res.msg : '服务异常')
            }
          }).finally(() => {
            this.addBtn_confirm = false
            this.getList()
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
      this.showAddDialog = false
    },
    addList () {
      this.showAddDialog = true
      this.$refs['formLabelAlign'].resetFields();
    },
    onClick (row) {
      console.log('插槽点击---->', row);
    },
    getList () {
      this.loading = true
      getPostList({ ...this.searchParams, ...this.pageObj }).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.tableData
          this.pageObj.total_count = res.data.total_count
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },


    handleSelectionClick (selection) {
      this.selection = selection
    },


  }

}
</script>
<style scoped>
::v-deep .orange-bg {
  background-color: #e6a23c !important;
}

::v-deep .green-bg {
  background-color: #4cd964 !important;
}

::v-deep .red-bg {
  background-color: #f56c6c !important;
}

.box {
  display: flex;
  flex-direction: column;
  padding: 10px;
  background-color: rgb(240, 243, 247);
}

.container {
  height: calc(100vh - 60px);
  padding: 15px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.el-form-item {
  /* padding-top: 22px !important; */
}

.btnList {
  height: 53px;
  background-color: rgb(250, 251, 250);
  line-height: 53px;
  padding: 0 2px;
  position: relative;

}

.btnList2 {
  background-color: rgb(250, 251, 250);
  line-height: 53px;
  padding: 0 2px;
  position: relative;
  margin-top: 8px;

}



.el-button--mini {
  /* margin-right: 8px; */
}

.el-button {
  margin-left: 8px !important;
  border-radius: 2px !important;
}

.table_content {
  padding: 10px 0;
}

.dialogTitle {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  border-bottom: 1px solid #f5f5f5;
}

.more {
  width: 12px;
  height: 12px;
  cursor: pointer;
}

.more:hover {
  color: #9a3434;
}

.operate_btn {
  display: flex;
  color: #666;
  font-size: 14px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.operate_btn>div {
  height: 32px;
  /* padding: 0 16px; */
  line-height: 32px;
  text-align: center;
  width: 100%;
  cursor: pointer;

}

.operate_btn>div:hover {
  background-color: rgb(242, 242, 242);
}
</style>



// WEBPACK FOOTER //
// src/views/formDesign/index.vue